import RoleService from '../../../services/roles/RoleService';
export default {
  data() {
    return {
      read: false,
      write: false,
      hiddenList: false,
      edit: false,
      delete: false,
      roleName: '',
      search: '',
      headers: [{
        text: "Nombre del Rol",
        sortable: false,
        value: "groupName"
      }],
      itemsData: [{
        groupName: "Admin",
        modules: "Todos",
        submodules: "pedidos"
      }],
    };
  },
  props: {},
  watch: {},
  created() {
    this.searchRoles()
    this.createRole()
  },
  methods: {
    createRole() {
      this.hiddenList = !this.hiddenList
    },
    saveRole () {
      if (this.roleName && this.roleName !== '') { 
        const id = this.itemsData.length + 1;
        RoleService.createRole(this.roleName, id).then(response => {
          this.searchRoles()
          this.hiddenList = !this.hiddenList
        }).catch((err) => {
          throw err
        }) 
      }else alert('Ingrese el Rol')   
    },

    onRowClick(item) {
      this.$emit("row-click", item);
    },
    searchRoles() {
      RoleService.getRoles().then(data => {
        this.itemsData = data.data
      })
    },
    searchOneRole() {
      RoleService.getOneRole(this.search).then(data => {
        this.itemsData = ''
        this.itemsData.push(data.data)
      })
    },
  }
};
